import { render, staticRenderFns } from "./TCStatistics.vue?vue&type=template&id=57b52bcf&"
import script from "./TCStatistics.vue?vue&type=script&lang=js&"
export * from "./TCStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports